import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// --->>>>>>>>>>>>>>>   All mobile user List api call   <<<<<<<<<<<<<<---
const SURVOYOR_LIST = ({
  commit
}) => {
  return ApiServices.getSurvoyorList()
    .then(response => {
      commit('getSurvoyorList', response)
      // console.log("getSurvoyorList=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Add mobile user List api call   <<<<<<<<<<<<<<---
const ADD_SURVOYOR = ({ commit }, data) => {
  return ApiServices.addSurvoyor(data)
    .then(response => {
      commit('survoyorAdd', response)
      // console.log("getSurvoyorList=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Add mobile user List api call   <<<<<<<<<<<<<<---
const UPDATE_SURVOYOR = ({
  commit
}, data) => {
  return ApiServices.updateSurvoyor(data)
    .then(response => {
      // commit('survoyorUpdate', response)
      // console.log("getSurvoyorList=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

const TOGGLE_USERS = ({
  commit
}, data) => {
  return ApiServices.toggleUser(data)
    .then(response => {
      // commit('survoyorUpdate', response)
      // console.log("getSurvoyorList=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

export default {
  SURVOYOR_LIST,
  ADD_SURVOYOR,
  UPDATE_SURVOYOR,
  TOGGLE_USERS
}


// WEBPACK FOOTER //
// ./src/store/modules/survoyor/actions.js